module.exports = __webpack_public_path__ + "static/media/icon-download.a82b9322.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-download.svg
// module id = 1244
// module chunks = 19